export const SESSION_STORAGE_KEYS = {
    SHOW_WELCOME_POPUP_OVERLAY: 'SHOW_WELCOME_POPUP_OVERLAY',
    SHOW_ONBOARDING_SUCCESS_POPUP_OVERLAY: 'SHOW_ONBOARDING_SUCCESS_POPUP_OVERLAY',
    SHOW_SIGN_UP_SUCCESS_MODAL: 'SHOW_SIGN_UP_SUCCESS_MODAL',
    COMPANY_NAME: 'COMPANY_NAME',
    INVITE_ID: 'INVITE_ID',
    GTC_POPUP_DISABLED: 'GTC_POPUP_DISABLED',
    AUTHENTICATION_STATE_VALUES: 'authenticationStateValues',
};
